import { Outlet } from "react-router-dom";
import About from "../About";
import Contact from "../Contact";
import Features from "../Features";
import Footer from "../Footer";
import Header from "../Header";
import Hero from "../Hero";
import Portfolio from "../Portfolio";
import Pricing from "../Pricing";
import Services from "../Services";
import Team from "../Team";
import Clients from "./clients";
import Testimonials from "./testimonials";
import Mission from "./mission";
import Category from "./category";
import HappyClients from "./happyClients";
import CoffeBike from "./coffeBike";
// import Business from "./business";
import HomeAbout from "./homeAbout";
import SEO from "../Common/SEO";

const Home = () => {
  return (
    <div className="index-page">
      <SEO 
        title="Custom Tricycle Carts & E-Cart Manufacturer"
        description="India's leading manufacturer of high-quality Tricycle Carts, E-Carts, and specialized Rickshaws. Trusted by major brands like Amul and Kwality Wall's."
        keywords="cart studio, tricycle carts, e-carts manufacturer, ice cream carts india, custom street food carts"
      />
      {/* <Header /> */}
      <main className="main">
        <Hero />
        {/* <CoffeBike /> */}
        <HomeAbout />
        <Mission />
        <Category />
        {/* <HappyClients /> */}
          <Clients />
        {/* <Business /> */}
        {/* <Features /> */}
        {/* <Testimonials /> */}
        {/* <Services /> */}
        {/* <Pricing /> */}
        {/* <Portfolio /> */}
        {/* <Team /> */}
        {/* <Contact /> */}
      </main>
      {/* <Outlet /> */}
      {/* <Footer /> */}
    </div>
  );
};
export default Home;
